module.exports = __webpack_public_path__ + "fonts/SFUIText-MediumItalic.6fbfb421.woff2";